/**
 * Recommended fixed embed-frame height (px) per exported sim block.
 *
 * Each sim block's rendered height VARIES across its auto-play loop —
 * policies get added, tranches append, fields fill and fade. A consumer
 * that wraps a block in a fixed frame must size that frame to the TALLEST
 * the block ever gets over a full loop, or the frame clips / jumps as the
 * animation plays.
 *
 * These values are the measured max content height over one full loop
 * (rendered from the built `dist/sim` bundle at the reference width the
 * showcase uses — 448px for the `max-w-md` widgets, 576px for `TradeWidget`,
 * 768px for the single-column program/neobank blocks, and 1120px for the
 * `NeobankProgramsOutcomeSim` two-pane rail+detail page), rounded UP to a
 * clean number. Pair
 * a block's frame `height` with the same reference width. See
 * `sim/IMPORT.md` → "Frame heights" for the per-block width and the
 * measured-vs-recommended table.
 *
 * Plain literal — no runtime deps. Keys are the exported component names.
 *
 * This lives in a **leaf module** (no imports) so the sim components can
 * read their own max height without importing through the `sim/index.ts`
 * barrel (which re-exports the very components that would need it — a
 * circular import). `sim/index.ts` re-exports this const; `SimFrame` and the
 * `framable` HOC import it directly from here.
 */
export const SIM_BLOCK_HEIGHTS: Record<string, number> = {
    BuyWidget: 576,
    TradeWidget: 800,
    YaasEnableRewardsSim: 512,
    PositionsPanel: 432,
    ProgramConfigurationSim: 400,
    ProgramPoliciesSim: 688,
    ProgramViewSim: 1376,
    ProgramActivationSim: 1376,
    NeobankContinuousProgramSim: 1200,
    NeobankDepositCampaignProgramSim: 1152,
    NeobankProgramsOutcomeSim: 1200,
    // Phone-frame master-detail (list ↔ Continuous detail); the detail scrolls
    // inside this fixed height.
    NeobankProgramsMobileSim: 760
};
